import React, { useEffect, useState } from "react";
import { FirtsStep } from "./components/FirtsStep";
import { SecondStep } from "./components/SecondStep";
import { simplyClick } from "./helpers";

function App() {
  const [formData, setFormData] = useState({});
  const [step, setStep] = useState(1);
  let content = null;

    useEffect(() => {
        const element =  document.getElementById('translation-checkpoint');
        if (!element) return;

        const initText = element.textContent.trim();
        let previousText = element.textContent.trim();

        const observer = new MutationObserver(() => {
            const currentText = element.textContent.trim();
            if (currentText !== previousText && initText !== currentText) {
                simplyClick("translation_detected", {
                    element: "link_disclosures",
                    text: currentText.slice(0, 1000)
                });
                previousText = currentText;
            }
        });

        observer.observe(element, {
            childList: true,
            characterData: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        }
    }, []);

  switch (step) {
    case 1:
      content = (
        <>
          <FirtsStep
            nextStep={() => setStep(2)}
            setData={setFormData}
            data={formData}
          />
        </>
      );
      break;
    case 2:
      content = (
        <>
          <SecondStep
            setData={setFormData}
            data={formData}
            nextStep={() => setStep(1)}
          />
        </>
      );
  }

  return <>{content}</>;
}

export default App;
